import axios from 'axios';
import parseOptions from './helpers/datasetToOptions';
import renderer, { AllowedComponentName, allowedComponentNames } from './renderer';

const componentNodes = document.querySelectorAll('[data-s-cape-component]');

function renderNodes() {
  componentNodes.forEach((node) => {
    const componentNameAttr = node.getAttribute('data-s-cape-component');

    if (!componentNameAttr) {
      throw new Error('Component name is required, use data-s-cape-component attribute with value');
    }

    if (!allowedComponentNames.includes(componentNameAttr as AllowedComponentName)) {
      throw new Error(`Invalid component name, use ${allowedComponentNames.join(', ')}`);
    }

    const componentName = componentNameAttr as AllowedComponentName;

    const options = parseOptions(componentName, node as HTMLElement);

    renderer({
      componentName,
      node,
      options,
    });
  });
}

async function enableMocking() {
  // In staging or production, we don't want to use the mock API.
  if (!import.meta.env.DEV) {
    return null;
  }

  // If mocking is explicitly disabled, we don't want to use the mock API.
  if (import.meta.env.VITE_ENABLE_MOCKING === 'false') {
    return null;
  }

  const { worker } = await import('./mocks/browser');

  return worker.start();
}

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

enableMocking().then(() => {
  renderNodes();
});
